import { formatDateRange } from "@notemeal/shared/ui/utils/dateTimes";
import React from "react";
import { Route, Routes, useSearchParams } from "react-router-dom-v5-compat";
import { getLink } from "../../../NavUtils";
import { RoleRoute } from "../../ProtectedRoutes";
import { NavLink } from "../../SecondaryNav/BreadCrumbs";
import { SecondaryNavLayout, SecondaryNavLayoutProps } from "../../SecondaryNav/SecondaryNavLayout";
import { kitchenLink, menuScheduleLink } from "../Kitchen/KitchenPaths";
import { ViewAttendancePage } from "./ViewAttendancePage";

export const getViewAttendancePath = () => `/org/view-attendance`;
export const getViewAttendanceLink = () => getLink("View Attendance", getViewAttendancePath());

const getSecondaryNavLayoutProps = (current: NavLink): SecondaryNavLayoutProps => ({
  name: "",
  current,
  breadCrumbs: [kitchenLink, menuScheduleLink],
  tabs: [],
  enableAthleteSearch: false,
});

export const ViewAttendanceRouter = () => {
  const [urlParams] = useSearchParams();

  const startDateIsoString = urlParams.get("startDate");
  const endDateIsoString = urlParams.get("endDate");

  //TODO: validity checks on date iso strings
  const pageHeader = formatDateRange(new Date(startDateIsoString!), new Date(endDateIsoString!));

  const current = { ...getViewAttendanceLink(), pageHeader };
  const secondaryNavLayoutProps = getSecondaryNavLayoutProps(current);

  return (
    <Routes>
      <Route element={<SecondaryNavLayout {...secondaryNavLayoutProps} />}>
        <Route element={<RoleRoute roles={["dietitian"]} />}>
          <Route index element={<ViewAttendancePage />} />
        </Route>
      </Route>
    </Routes>
  );
};
